jQuery(document).ready(function($) {

  $.ajax({
    method: 'GET',
    url: ajaxurl,
    dataType: "json",
    data: {
      security: window.stockPriceAjax,
      action: 'stock_price_ajax'
    },
    success : function(response) {

        if(response.success){

          var json = JSON.parse(response.data.data);

          $.each(json, function(index, item) {
            var exchange = item.code;
            var price = item.close ? item.close.toFixed(2) : '';

            var button = $('[data-stock="' + exchange + '"] ');
            var symbol = button.data('symbol');
            var currency = button.data('currency');

            var target = button.find('span');

            if (price) {
              target.text(currency + ' ' + symbol +  price);
            } else {
              target.text('View Price ↗');
            }
            
          });

        } else {
          var stockLinks = $('[data-stock]');

          $.each(stockLinks, function(index, item) {
            var target = $(item).find('span');
            target.text('View Price ↗');
          });
        }

      }
  });
  
});
